<div class="name-container all-fields">
  <div class="name-text all-texts">{{'YOUR_NAME' | translate}}:</div>
  <input #name class="name-value all-values"/>
</div>
<div class="email-container all-fields">
  <div class="email-text all-texts">{{'EMAIL' | translate}}:</div>
  <input #email (input)="onEmailInput(email.value)" [class.error]="error=='email'" class="email-value all-values"/>
</div>
<div class="phone-container all-fields">
  <div class="phone-text all-texts">{{'PHONE' | translate}}:</div>
  <input #phone class="phone-value all-values"/>
</div>
<div class="message-container all-fields">
  <div class="message all-texts">Запитване:</div>
  <textarea #message (input)="onRequestInput(message.value)" [class.error]="error=='message'"
            class="message-value all-values" rows="4"></textarea>
</div>
<re-captcha class="contact-form-recaptcha" (resolved)="handleCorrectCaptcha()" [class.error]="error=='captcha'"></re-captcha>
<div class="submit-button" (click)="clickOnSendButton(name.value,email.value,phone.value,message.value)">
  <div class="submit-button-text"> {{ 'SEND' | translate | uppercase}} </div>
</div>
